export default __webpack_public_path__ + "static/media/avatar3.786b59fa.png";